// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1H6CO","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__L3240"};